/* Copyright (c) 2023 Nordcloud Oy or its affiliates. All Rights Reserved. */

import { When } from "react-if";
import { Text, theme } from "@nordcloud/gnui";
import { isNotEmpty } from "~/tools";

type DetailProps = {
  value: string;
  bold?: boolean;
  isVerticalBar?: boolean;
  isEllipsis?: boolean;
};

export function ResourceDetails({
  value,
  bold,
  isEllipsis,
  isVerticalBar,
}: DetailProps) {
  return (
    <When condition={isNotEmpty(value)}>
      <Text
        size="sm"
        tag="span"
        color={theme.color.text.text02}
        mr={theme.spacing.spacing01}
        weight={bold ? "medium" : "regular"}
        css={
          isEllipsis
            ? {
                maxWidth: "30%",
                textOverflow: "ellipsis",
                overflow: "hidden",
                whiteSpace: "nowrap",
              }
            : undefined
        }
      >
        {`${value} ${isVerticalBar ? "| " : ""}`}
      </Text>
    </When>
  );
}
